import { LoginResponseDto } from '@/api/generated';
import { createContext, Dispatch, SetStateAction } from 'react';

export interface AuthenticationDataContextProps {
  authenticationData: LoginResponseDto | null;
  setAuthenticationData: Dispatch<SetStateAction<LoginResponseDto | null>>;
}

export const AuthenticationDataContext = createContext<AuthenticationDataContextProps | undefined>(
  undefined,
);
